import {StateValue} from "@webfruits/toolbox/dist/state/StateValue";
import {Hotspot} from "../systems/illustration/hotspots/Hotspot";

/******************************************************************
 * CoreState
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class CoreState {

    public readonly HOVERED_HOTSPOT = new StateValue<Hotspot>(null);
    public readonly SELECTED_HOTSPOT = new StateValue<Hotspot>(null);
    public readonly COPY_SCROLL_TOP = new StateValue<number>(0);

}


